export class ToastStateModel {
  toasts: Toast[];
}

export class Toast {
  type: string;
  classname: string;
  header: string;
  text: string;
  delay: number;
  autohide: boolean;
}
